import React, { useId } from 'react';

export default function GalagoLogo({ size = 32, className = '' }) {
  const gradientId = useId();

  return (
    <svg viewBox="0 0 40 40" width={size} height={size} className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF6B6B" />
          <stop offset="50%" stopColor="#FFD93D" />
          <stop offset="100%" stopColor="#6C63FF" />
        </linearGradient>
      </defs>
      <circle cx="20" cy="20" r="19" fill={`url(#${gradientId})`} />
      <circle cx="20" cy="21" r="12" fill="#1a1a1a" opacity="0.15" />
      <ellipse cx="10" cy="11" rx="5.5" ry="8" fill="white" opacity="0.95" transform="rotate(-10,10,11)" />
      <ellipse cx="10" cy="11" rx="3.5" ry="5.5" fill={`url(#${gradientId})`} opacity="0.3" transform="rotate(-10,10,11)" />
      <ellipse cx="30" cy="11" rx="5.5" ry="8" fill="white" opacity="0.95" transform="rotate(10,30,11)" />
      <ellipse cx="30" cy="11" rx="3.5" ry="5.5" fill={`url(#${gradientId})`} opacity="0.3" transform="rotate(10,30,11)" />
      <circle cx="20" cy="21" r="11.5" fill="white" />
      <circle cx="15" cy="20" r="4.5" fill="#1a1a1a" />
      <circle cx="15" cy="20" r="3.2" fill="#FFD93D" />
      <circle cx="15" cy="20" r="1.8" fill="#1a1a1a" />
      <circle cx="14" cy="19" r="1" fill="white" opacity="0.85" />
      <circle cx="25" cy="20" r="4.5" fill="#1a1a1a" />
      <circle cx="25" cy="20" r="3.2" fill="#FFD93D" />
      <circle cx="25" cy="20" r="1.8" fill="#1a1a1a" />
      <circle cx="24" cy="19" r="1" fill="white" opacity="0.85" />
      <ellipse cx="20" cy="24.5" rx="1.8" ry="1.2" fill="#1a1a1a" opacity="0.4" />
      <path d="M 17 26 Q 20 28.5 23 26" fill="none" stroke="#1a1a1a" strokeWidth="0.8" opacity="0.3" strokeLinecap="round" />
      <line x1="11" y1="19.5" x2="8.5" y2="17.5" stroke="#1a1a1a" strokeWidth="0.7" opacity="0.15" strokeLinecap="round" />
      <line x1="29" y1="19.5" x2="31.5" y2="17.5" stroke="#1a1a1a" strokeWidth="0.7" opacity="0.15" strokeLinecap="round" />
    </svg>
  );
}
